export enum CategorySlugs {
  PALLET_RACKING_MULTI_TIER_SYSTEM = "pallet-racking-multi-tier-system",
  LONGSPAN_MULTI_TIER_SYSTEM = "longspan-multi-tier-system",
  BOLTLESS_MULTI_TIER_SYSTEM = "boltless-multi-tier-system",
  MOBILE_SHELVING = "mobile-shelving",
  LONGSPAN_SHELVING = "longspan-shelving",
  BOLTLESS_SHELVING = "boltless-shelving",
  ADJUSTABLE_PALLET_RACKING_APR = "adjustable-pallet-racking-apr",
  DRIVE_THROUGH = "drive-through",
  DRIVE_IN = "drive-in",
  SHUTTLE_RACKING = "shuttle-racking",
}

export const CategoriesSlugWithSummaries = [
  CategorySlugs.ADJUSTABLE_PALLET_RACKING_APR,
  CategorySlugs.DRIVE_IN,
  CategorySlugs.DRIVE_THROUGH,
  CategorySlugs.SHUTTLE_RACKING,
];

export interface SummaryFieldType {
  type: "input" | "select";
  unit?: string;
  label: string;
  key: string;
  options?: { label: string; value: string }[];
}

export const SummaryBlockLabel: Partial<Record<CategorySlugs, string>> = {
  [CategorySlugs.ADJUSTABLE_PALLET_RACKING_APR]: "Run Type",
  [CategorySlugs.DRIVE_IN]: "Block",
  [CategorySlugs.DRIVE_THROUGH]: "Block",
  [CategorySlugs.SHUTTLE_RACKING]: "Block",
};

export const SummaryFieldsSchema: Partial<
  Record<CategorySlugs, SummaryFieldType[]>
> = {
  [CategorySlugs.ADJUSTABLE_PALLET_RACKING_APR]: [
    { type: "input", label: "Number of Runs", key: "number_of_runs" },
    {
      type: "select",
      label: "Run Type",
      key: "run_type",
      options: [
        { label: "Single Run", value: "single-run" },
        { label: "Back-To-Back Run", value: "back-to-back-run" },
      ],
    },
    { type: "input", label: "Number of Bays Long", key: "number_of_bays_long" },
    {
      type: "input",
      label: "Total Run Height",
      key: "total_run_height",
      unit: "mm",
    },
    {
      type: "input",
      label: "Total Run Length",
      key: "total_run_length",
      unit: "mm",
    },
    {
      type: "input",
      label: "Total Run Depth",
      key: "total_run_depth",
      unit: "mm",
    },
    {
      type: "input",
      label: "Max Load per Level",
      key: "max_load_per_level",
      unit: "kg",
    },
    {
      type: "input",
      label: "Max Load per Bay",
      key: "max_load_per_bay",
      unit: "kg",
    },
  ],
  [CategorySlugs.DRIVE_IN]: [
    { type: "input", label: "Number of Lanes", key: "number_of_lanes" },
    { type: "input", label: "Lane Width", key: "lane_width", unit: "mm" },
    { type: "input", label: "Max Levels (G+)", key: "max_levels" },
    {
      type: "input",
      label: "Total Block Height",
      key: "total_block_height",
      unit: "mm",
    },
    {
      type: "input",
      label: "Total Block Width",
      key: "total_block_width",
      unit: "mm",
    },
    {
      type: "input",
      label: "Total Block Depth",
      key: "total_block_depth",
      unit: "mm",
    },
    {
      type: "input",
      label: "Max Load per Level",
      key: "max_load_per_level",
      unit: "kg",
    },
    {
      type: "input",
      label: "Max Load per Lane",
      key: "max_load_per_lane",
      unit: "kg",
    },
  ],
  [CategorySlugs.DRIVE_THROUGH]: [
    { type: "input", label: "Number of Lanes", key: "number_of_lanes" },
    { type: "input", label: "Lane Width", key: "lane_width", unit: "mm" },
    { type: "input", label: "Max Levels (G+)", key: "max_levels" },
    {
      type: "input",
      label: "Total Block Height",
      key: "total_block_height",
      unit: "mm",
    },
    {
      type: "input",
      label: "Total Block Width",
      key: "total_block_width",
      unit: "mm",
    },
    {
      type: "input",
      label: "Total Block Depth",
      key: "total_block_depth",
      unit: "mm",
    },
    {
      type: "input",
      label: "Max Load per Level",
      key: "max_load_per_level",
      unit: "kg",
    },
    {
      type: "input",
      label: "Max Load per Lane",
      key: "max_load_per_lane",
      unit: "kg",
    },
  ],
  [CategorySlugs.SHUTTLE_RACKING]: [
    { type: "input", label: "Number of Lanes", key: "number_of_lanes" },
    { type: "input", label: "Lane Width", key: "lane_width", unit: "mm" },
    { type: "input", label: "Max Levels (G+)", key: "max_levels" },
    {
      type: "input",
      label: "Total Block Height",
      key: "total_block_height",
      unit: "mm",
    },
    {
      type: "input",
      label: "Total Block Width",
      key: "total_block_width",
      unit: "mm",
    },
    {
      type: "input",
      label: "Total Block Depth",
      key: "total_block_depth",
      unit: "mm",
    },
    {
      type: "input",
      label: "Max Load per Level",
      key: "max_load_per_level",
      unit: "kg",
    },
    {
      type: "input",
      label: "Max Load per Lane",
      key: "max_load_per_lane",
      unit: "kg",
    },
  ],
};
